import { v4 as uuidv4 } from 'uuid'
import { S3Client, PutObjectCommand, ObjectCannedACL} from "@aws-sdk/client-s3"

const sessionTokenKey = 'X-Amz-Session-Token';
const accessKeyHeader = 'X-Amz-Access-Key';
const secretKeyHeader = 'X-Amx-Secret-Key';
const accessTokenExpiryHeader = 'X-Amz-Session-Expiry';
export const businessIdHeader = 'businessid';
export const businessesHeader = 'businesses';
export const loyaltyOffersSession = 'loyaltyoffers';
export const userRoleHeader = 'User-Role';
export const userIdHeader = 'User-Id';
const securityToken = 'X-Amz-Security-Token';
export const httpOKsuccess = '200';
export const httpNotFound = '404';
export const httpConflict = '409';
const amzDate = 'X-Amz-Date';
const hostHeader = 'Host';
export const emailHeader = 'EMail';
export const redirectReasonHeader = 'Redirect-Reason';
export const actionRequiredHeader = 'Action-Required';
export const passwordIssueHeader = 'Password-Issue';
export const emailAlreadyInUseHeader = 'Email-Address-is-already-in-use';
export const emailIssueHeader = 'Email-Issue';
export const enabledContactRequestHeader = 'Enabled-Contact-Requests';
export const redirectToParam = 'redirectTo';
export const getMethod = 'GET';
export const postMethod = 'POST';
export const putMethod = 'PUT';
export const cssFormInput = 'form-input';
export const cssFormInputLabel = 'form-input-label';
export const cssFormInputText = 'form-input-text';
export const cssFormInputTextArea = 'form-input-text-area';
export const cssFormInputButton = 'form-input-button';
export const cssFormInputFile = 'form-input-file';
export const cssFormCheckBox = 'form-check-box';
export const cssTableCheckBox = 'table-check-box';
export const cssError = 'error';
export const cssFormInputNumber = 'form-input-number';
export const cssFormInputDropdown = 'form-input-dropdown';
export const cssFormInputHidden = 'form-input-hidden';
export const cssFormInline = 'form-inline';
export const cssTextDark = 'text-dark';
export const cssContactRequestSection = 'contact-request-section';
export const cssContactRequestField = 'contact-request-field';
export const cssContactRequestFieldActions = 'contact-request-field-actions';
export const https = 'https://';
export const s3resource = '.s3.';
export const awsLocation = '.amazonaws.com/';
export const fileFieldType = 'file';
export const textField = 'text';
export const numberField = 'number';
export const timeField = 'time';
export const passwordField = 'password';
export const checkBox = 'checkbox';
export const buttonType = 'button';
export const roleAdministrator = 'Administrators';
export const roleAgent = 'Agents';
export const roleMerchant = 'Merchants';
export const roleFranchisor = 'Franchisors';
export const roleMerchantAdministrator = 'MerchantAdministrators';
export const posIntegration = false;
export const emailRegularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const notificationTitleLength = 65;
export const notificationBodyLength = 178;
export const standardTextLength = 255;
export const longTextLength = 2000;
export const standardMinusTextLength = 200;
export const emailAddressLength = 320;
export const passwordLength = 99;
export const cognitoAttributeLength = 2048;
export const longDisplayDateAndTimeFormat = 'd MMM yyyy HH:MM';

export async function isLoggedIn() {

	if (!((sessionStorage.getItem(sessionTokenKey) && isAWSSessionValid()))) {
		await login()
			.then((loggedIn) => {
				if (loggedIn) {
					return true;
				} else {

					var currentPage = window.location.protocol + '//' + window.location.host + window.location.pathname;
					window.location.href = '/logon?' + redirectToParam + '=' + encodeURIComponent(currentPage);
				}
			});
	} else {
		return true;
	}

}

function isDevelopmentEnvironment() {
	return !process.env.NODE_ENV || process.env.REACT_APP_API_ENDPOINT.includes('localhost') || process.env.REACT_APP_API_ENDPOINT.includes('ngrok');
}

export function protocolAndHostname() {

	const businessId = getSessionValue(businessIdHeader);
	
	const business = getSessionValue(businessesHeader)[0];//.map(bu => bu.businessId == businessId)[0];

	if (business.isWhiteLabelled && !isDevelopmentEnvironment()) {
		const colonDoubleDash = "://";
		const baseUrl = process.env.REACT_APP_API_ENDPOINT;
		const scheme = baseUrl.split(colonDoubleDash)[0];
		const protocolAndPathName = baseUrl.split(colonDoubleDash)[1];

		if (protocolAndPathName.startsWith("rsnrs")) {
			return scheme + colonDoubleDash + business.whiteLabelPrefix + protocolAndPathName;
		} else {
			const environment = protocolAndPathName.split(".")[0];
			const remainingProtocolandPathName = protocolAndPathName.substring(protocolAndPathName.indexOf("."));
			console.log(scheme + colonDoubleDash + environment + "." + business.whiteLabelPrefix + remainingProtocolandPathName);
			return scheme + colonDoubleDash + environment + "." + business.whiteLabelPrefix + remainingProtocolandPathName;
		}
	}

	return process.env.REACT_APP_API_ENDPOINT;
}

let loginPromise = null;

export async function login() {

	if (loginPromise) {
		return loginPromise;
	}

	loginPromise = new Promise(async (resolve, reject) => {
		try {
			var succesful;

			var merchantId = new URLSearchParams(window.location.search).get('merchant_id');
			var employeeId = new URLSearchParams(window.location.search).get('employee_id');
			var clientId = new URLSearchParams(window.location.search).get('client_id');
			var code = new URLSearchParams(window.location.search).get('code');


			if (merchantId && employeeId && clientId && code) {

				const loginResponse = await fetch(protocolAndHostname() + 'clover/login?merchant_id=' + merchantId + '&employee_id=' + employeeId + '&client_id=' + clientId + '&code=' + code);

				succesful = (loginResponse.status == httpOKsuccess);

				if (succesful) {
					const headers = await loginResponse.headers;

					writeLoginTokensToSession(headers);
					const data = await loginResponse.json();
					sessionStorage.setItem(businessesHeader, JSON.stringify(data));

					const loyaltyOfferResponse = await fetchSignedMessage(null, 'business/' + getSessionValue(businessIdHeader) + '/loyaltyoffers', getMethod)

					const loyaltyOffersData = await loyaltyOfferResponse.json();
					sessionStorage.setItem(loyaltyOffersSession, JSON.stringify(loyaltyOffersData));
				}

				resolve(succesful);
			}
			resolve(false);
		} catch (error) {
			reject(error);
		} finally {
			loginPromise = null;
		}


	});

	return loginPromise;
}
export function logout() {
	sessionStorage.clear();
	var currentPage = window.location.protocol + '//' + window.location.host + window.location.pathname;
	window.location.href = '/logon?' + redirectToParam + '=' + encodeURIComponent(currentPage);
}

export function writeLoginTokensToSession(loginResponseHeaders) {
	writeHeaderToSession(loginResponseHeaders, sessionTokenKey);
	writeHeaderToSession(loginResponseHeaders, accessKeyHeader);
	writeHeaderToSession(loginResponseHeaders, secretKeyHeader);
	writeHeaderToSession(loginResponseHeaders, accessTokenExpiryHeader);
	writeHeaderToSession(loginResponseHeaders, userRoleHeader);
	writeHeaderToSession(loginResponseHeaders, userIdHeader);
	writeBooleanHeaderToSession(loginResponseHeaders, enabledContactRequestHeader);

	writeFirstBusinessIdToBusinessIdHeader(loginResponseHeaders);
}

function writeFirstBusinessIdToBusinessIdHeader(loginResponseHeaders) {
	sessionStorage.setItem(businessIdHeader, JSON.stringify(loginResponseHeaders.get(businessIdHeader).split(',')[0]));
}

export async function merchantHasLoyaltyOffers() {

	var businessId;

	while (businessId == null) {
		businessId = getSessionValue(businessIdHeader);
		if (businessId == null) {
			await sleep(tenthOfASecond);
		}
	}

	const response = await fetchSignedMessage(null, 'business/' + businessId + '/loyaltyoffers', getMethod);
	const data = await response.json();
	return (data.length > 0);
	
}

const sleep = ms => new Promise(
	resolve => setTimeout(resolve, ms)
);

function writeHeaderToSession(headers, key) {
	sessionStorage.setItem(key, JSON.stringify(headers.get(key)));
}

function writeBooleanHeaderToSession(headers, key) {
	sessionStorage.setItem(key, headers.get(key) === 'True');
}

export function getSessionValue(key) {
	const tokenString = sessionStorage.getItem(key);
	return JSON.parse(tokenString);
}

export function isAWSSessionValid() {

	var tokenExpiryDate = new Date(getSessionValue(accessTokenExpiryHeader));
	var now = new Date();

	return (tokenExpiryDate > now);

}

export function postAttachment(attachment) {
	//https://stackoverflow.com/questions/74303350/react-how-to-upload-files-to-aws-s3-in-react-using-aws-sdk-client-s3-npm-pack
	if (isAWSSessionValid()) {
		const s3Client = new S3Client({
			apiVersion: '2010-08-01',
			region: process.env.REACT_APP_AWS_REGION,
			credentials: {
				accessKeyId: getSessionValue(accessKeyHeader),
				secretAccessKey: getSessionValue(secretKeyHeader),
				sessionToken: getSessionValue(sessionTokenKey)
			},
		});

		var fileType = attachment.type.split("/")[1];

		var uploadedFileName = uuidv4() + "." + fileType;

		const params = {
			Bucket: process.env.REACT_APP_MESSAGE_BUCKET_NAME,
			Key: uploadedFileName,
			Body: attachment,
			ACL: ObjectCannedACL.public_read
		};

		const command = new PutObjectCommand(params);
		const data = s3Client.send(command);
		console.log(data);

		return uploadedFileName;
	} else {
		isLoggedIn();
	}
}

export function uploadFileToBucket(file, bucket) {
	//https://stackoverflow.com/questions/74303350/react-how-to-upload-files-to-aws-s3-in-react-using-aws-sdk-client-s3-npm-pack
	if (isAWSSessionValid()) {
		const s3Client = new S3Client({
			apiVersion: '2010-08-01',
			region: process.env.REACT_APP_AWS_REGION,
			credentials: {
				accessKeyId: getSessionValue(accessKeyHeader),
				secretAccessKey: getSessionValue(secretKeyHeader),
				sessionToken: getSessionValue(sessionTokenKey)
			},
		});

		var fileType = file.type.split("/")[1];

		var uploadedFileName = uuidv4() + "." + fileType;

		const params = {
			Bucket: bucket,
			Key: uploadedFileName,
			Body: file,
			ACL: ObjectCannedACL.public_read
		};

		const command = new PutObjectCommand(params);
		const data = s3Client.send(command);
		console.log(data);

		return uploadedFileName;
	} else {
		isLoggedIn();
	}
}

export function fetchSignedMessage(messageData, endpoint, method) {

	if (isAWSSessionValid()) {
		const baseUrl = process.env.REACT_APP_API_ENDPOINT;
		const indexOfFirstForwardslashes = baseUrl.indexOf("//") + 2;
		const indexOfSecondForwardSlash = baseUrl.indexOf("/", indexOfFirstForwardslashes);
		const host = baseUrl.substring(indexOfFirstForwardslashes, indexOfSecondForwardSlash);
		const region = process.env.REACT_APP_AWS_REGION;
		const service = 'execute-api';

		if (isDevelopmentEnvironment()) {
			return fetch(baseUrl + endpoint, {
				method: method,
				body: messageData,
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((response => {
				return response;
				console.log(response.status + ":" + response.statusText + ":" + response.text);
            }));
		} else {

			var today = new Date();
			let awsDate = today.getUTCFullYear().toString() + getTwoDigitTime(today.getUTCMonth() + 1) + getTwoDigitTime(today.getUTCDate()) + 'T' + getTwoDigitTime(today.getUTCHours()) + getTwoDigitTime(today.getUTCMinutes()) + getTwoDigitTime(today.getUTCSeconds()) + 'Z';
			let dateStamp = today.getUTCFullYear().toString() + getTwoDigitTime(today.getUTCMonth() + 1) + getTwoDigitTime(today.getUTCDate());

			var endOfHostWithinBaseUrl = baseUrl.indexOf(host) + host.length;
			var canonicalUrl = baseUrl.substring(endOfHostWithinBaseUrl) + endpoint;

			var canonicalQueryString = '';
			var canonicalHeaders = hostHeader.toLowerCase() + ':' + host + '\n' + amzDate.toLowerCase() + ':' + awsDate + '\n' + securityToken.toLowerCase() + ':' + getSessionValue(sessionTokenKey) + '\n';
			var signedHeaders = `${hostHeader.toLowerCase()};${amzDate.toLowerCase()};${securityToken.toLowerCase()}`;

			let canonicalRequest = method + '\n' + canonicalUrl + '\n' + canonicalQueryString + '\n' + canonicalHeaders + '\n' + signedHeaders + '\n' + hashOfString(messageData);

			let algorithm = 'AWS4-HMAC-SHA256';
			let credentialScope = dateStamp + '/' + region + '/' + service + '/' + 'aws4_request';
			let stringToSign = algorithm + '\n' + awsDate + '\n' + credentialScope + '\n' + hashOfString(canonicalRequest);

			let signingKey = getSignatureKey(getSessionValue(secretKeyHeader), dateStamp, region, service)
			var CryptoJS = require("crypto-js");
			let signature = CryptoJS.HmacSHA256(stringToSign, signingKey).toString(CryptoJS.enc.Hex);

			let authorizationHeader = algorithm + ' ' + 'Credential=' + getSessionValue(accessKeyHeader) + '/' + credentialScope + ', ' + 'SignedHeaders=' + signedHeaders + ', ' + 'Signature=' + signature

			if (method == getMethod) {
				return fetch(baseUrl + endpoint, {
					method: method,
					headers: {
						'Authorization': authorizationHeader,
						'X-Amz-Date': awsDate,
						'X-Amz-Security-Token': getSessionValue(sessionTokenKey)
					}
				});
			} else {
				return fetch(baseUrl + endpoint, {
					method: method,
					body: messageData,
					headers: {
						'Authorization': authorizationHeader,
						'X-Amz-Date': awsDate,
						'X-Amz-Security-Token': getSessionValue(sessionTokenKey),
						'Content-Type': 'application/json'
					}
				});
            }
		}
	} else {
		isLoggedIn();
	}
}


function hashOfString(valueToHash) {
	var CryptoJS = require("crypto-js");
	return CryptoJS.SHA256(valueToHash).toString(CryptoJS.enc.Hex);
}

function getSignatureKey(key, dateStamp, regionName, serviceName) {

	var crypto = require("crypto-js");

	var kDate = crypto.HmacSHA256(dateStamp, "AWS4" + key);
	var kRegion = crypto.HmacSHA256(regionName, kDate);
	var kService = crypto.HmacSHA256(serviceName, kRegion);
	var kSigning = crypto.HmacSHA256("aws4_request", kService);
	return kSigning;
}

function getTwoDigitTime(number) {
	return number.toString().padStart(2, '0');
}


export function getBusinessIdAndWaitTillItIsSaved() {

	var businessId;
	const tenthOfASecond = 100;

	while (businessId == null) {
		businessId = getSessionValue(businessIdHeader);
		if (businessId == null) {
			sleep(tenthOfASecond);
		}
	}
	return businessId;
}

export const TimePeriodSpecifier = ({ title, yearField, monthField, dayField, dayPartField, onChangeFunction }) => {
	return (<><label className={cssFormInputLabel}>{title}</label>
		<div class={cssFormInline}><label className={cssFormInputLabel} for={yearField}>Years:</label><input type={numberField} className={cssFormInputNumber} name={yearField} id={yearField} onChange={onChangeFunction} /></div>
		<div class={cssFormInline}><label className={cssFormInputLabel} for={monthField}>Months:</label><input type={numberField} className={cssFormInputNumber} name={monthField} id={monthField} onChange={onChangeFunction} /></div>
		<div class={cssFormInline}><label className={cssFormInputLabel} for={dayField}>Days:</label><input type={numberField} className={cssFormInputNumber} name={dayField} id={dayField} onChange={onChangeFunction} /></div>
		<div class={cssFormInline}><label className={cssFormInputLabel} for={dayPartField}>Hours and minutes:</label><input type={timeField} step="1" className={cssFormInputNumber} name={dayPartField} id={dayPartField} onChange={onChangeFunction} /></div></>);
}

export function getTicksFromHHMMSS(hhmmss) {
	const tenMillionTicksInASecond = 10000000;
	const [hours, minutes, seconds] = hhmmss.split(':');
	return ((+hours) * 60 * 60 + (+minutes) * 60 + (+seconds)) * tenMillionTicksInASecond;
}